import React from 'react';

export default class Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToGiveFeedback');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>If you remember three things, make them the following:</p>
                                            <p><span className="brown boldtext nextt">1.</span><span
                                                className="nextt1">Feedback is a two-way process and works best when the personal needs and objectives of the feedback giver and receiver are both met.</span>
                                            </p>
                                            <p><span className="brown boldtext nextt">2.</span><span
                                                className="nextt1">An appreciative approach to feedback will enable you to get the most from your employees.</span>
                                            </p>
                                            <p><span className="brown boldtext nextt">3.</span><span
                                                className="nextt1" style={{paddingBottom: '30px'}}>You will need to flex your feedback style depending on the needs of the individuals you are giving feedback to.</span>
                                            </p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad greennumberroundbg1 lightbgcontentShrink uiheading">
                                                <p>Next time you are giving feedback, whether in a performance
                                                    review meeting or after watching someone in a meeting, take
                                                    these three points into account and watch the results!</p>
                                            </div>
                                            <br/>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>

                                            <div className="paraspace">
                                                <p>If you found this tool useful then you are likely to find
                                                    the following tools both insightful and relevant:</p>
                                            </div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                        to be assertive</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                        to influence others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToCommunicateEffectively')}>How
                                                        to communicate effectively</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToActivelyListen')}>How
                                                        to actively listen</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToManageDifficultConversations')}>How
                                                        to manage difficult conversations</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToSupportAndChallengeInTandem')}>How
                                                        to support and challenge in tandem</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToDevelopOthers')}>How
                                                        to develop others.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Forer, B. (1949).
                                                    The fallacy of personal validation: A classroom
                                                    demonstration of gullibility.<span
                                                        className="subtiltereg">  Journal of Abnormal and Social Psychology,</span> 44,
                                                    118-123.</p></li>
                                                <li><p className="further_info_content">Croft,
                                                    A., &amp; Schmader, T. (2012). The feedback withholding
                                                    bias: Minority students do not receive critical feedback
                                                    from evaluators concerned about appearing racist.<span
                                                        className="subtiltereg">  Journal of Experimental Social Psychology.</span>
                                                </p></li>
                                                <li><p className="further_info_content"> Cooperrider, D.
                                                    L., &amp; Whitney, D. (2001). A positive revolution in
                                                    change: Appreciative inquiry.<span
                                                        className="subtiltereg">  Public Administration and Public Policy,</span> 87,
                                                    611-630.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}